import { render, staticRenderFns } from "./AboutFooter.vue?vue&type=template&id=1240e1a2&scoped=true"
var script = {}
import style0 from "./AboutFooter.vue?vue&type=style&index=0&id=1240e1a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1240e1a2",
  null
  
)

export default component.exports